import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SetupState = {
  accountCreated: boolean;
  themeSelected: boolean;
  storeSetup: boolean;
  supplierConnected: boolean;
  productsImported: boolean;
  paymentIntegrated: boolean;
  testOrderDone: boolean;
};

const initialState: SetupState = {
  accountCreated: true,
  themeSelected: false,
  storeSetup: false,
  supplierConnected: false,
  productsImported: false,
  paymentIntegrated: false,
  testOrderDone: false,
};

const setupSlice = createSlice({
  name: "setup",
  initialState,
  reducers: {
    updateStep: (state, action: PayloadAction<keyof SetupState>) => {
      state[action.payload] = true;
    },
  },
});

export const { updateStep } = setupSlice.actions;
export default setupSlice.reducer;